// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonIdentityPicker = {
  treeTitle: "组织",
  treeSearchPlaceholder: "搜索组织",
  treeLoading: "组织加载中",
  treeEmpty: "暂无可选组织",
  tableTitlePrefix: "用户列表",
  selectOrganization: "请选择组织",
  organizationNode: "组织节点",
  selectedUsersTitle: "已选成员",
  selectedUsersEmpty: "尚未选择成员",
  pickMembersFromOrganization: "从组织中选择成员",
  emptyInCurrentScope: "当前组织范围内没有可加入成员",
  emptyBeforeOrganization: "请先选择组织",
  loadDataFailed: "加载组织选人数据失败",
  missingMembershipListApi: "加载组织成员失败：缺少组织成员列表接口",
  loadMembersFailed: "加载组织成员失败",
  loadUserDetailsFailed: "加载用户详情失败",
  searchField: "搜索{field}",
  columns: {
    allOrganizationMemberships: "全部组织归属",
  },
  actions: {
    remove: "移除",
  },
} as const;
